import script from "./UploadSection.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadSection.vue?vue&type=script&setup=true&lang=js"

import "./UploadSection.vue?vue&type=style&index=0&id=5742a547&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5742a547"]])

export default __exports__